import { gql } from '../../../__generated__/gql';

export const CREATE_QUOTATION_SERVICE = gql(`
  mutation createQuotationService(
    $quotation: ID!
    $description: String!
    $order: Int!
    $parent: ID!
    $serviceWage: ID!
    $serviceTime: Int!
    ){
      createQuotationService(
        input: {
          quotation: $quotation,
          description: $description,
          order: $order,
          parent: $parent,
          serviceWage: $serviceWage,
          serviceTime: $serviceTime,
        }
      )
    { 
      response
      errors{
        field
        messages
      }
    }
  }
`);

export const UPDATE_SERVICE_NOTES = gql(`
  mutation updateServiceNotes(
    $quotation: ID!,
		$notes: String!,
		$service: ID!,
    ){
      updateServiceNotes(
        input: {
          quotation: $quotation,
          notes: $notes,
          service: $service,
        }
      )
    { 
      response
      errors{
        field
        messages
      }
    }
  }
`);

export const UPDATE_SERVICE_DESCRIPTION = gql(`
  mutation updateServiceDescription(
    $quotation: ID!
    $service: ID!
    $description: String!
  ){
    updateServiceDescription(
      input: {
        quotation: $quotation
        service: $service
        description: $description
      }
    ){
      response
      errors{
        field
        messages
      }
    }
  }
`);

export const UPDATE_SERVICE_WAGE = gql(`
  mutation updateServiceWage(
    $serviceWage: ID!
    $service: ID!
    $quotation: ID!
    ){
      updateServiceWage(
        input: {
          serviceWage: $serviceWage
          service: $service
          quotation: $quotation
        }
      )
    { 
      response
      errors{
        field
        messages
      }
    }
  }
`);

export const UPDATE_SERVICE_TIME = gql(`
  mutation updateServiceTime(
    $serviceTime: Int!
    $service: ID!
    $quotation: ID!
    ){
      updateServiceTime(
        input: {
          serviceTime: $serviceTime
          service: $service
          quotation: $quotation
        }
      )
    { 
      response
      errors{
        field
        messages
      }
    }
  }
`);

export const UPDATE_SERVICE_PROFIT_SURCHARGE = gql(`
  mutation updateServiceProfitSurcharge(
    $service: ID!
    $profitSurcharge: Decimal!
    $quotation: ID!
  ){
    updateServiceProfitSurcharge(
      input: {
        service: $service
        profitSurcharge: $profitSurcharge
        quotation: $quotation
      }
    ){ 
      response
      errors{
        field
        messages
      }
    }
  }
`);